/**
 * Labstep
 *
 * @desc Edit a permissionRole table
 */

import { PermissionRoleFormEdit } from 'labstep-web/components/PermissionRole/Form/Edit';
import { ActionComponentModalContainer as ActionComponent } from 'labstep-web/core/Action/Component';
import { ModalDefaultContainer as ModalDefault } from 'labstep-web/core/Modal/Default';
import type React from 'react';
import type { IPermissionRoleActionEditProps } from './types';

export const PermissionRoleActionEdit: React.FC<
  IPermissionRoleActionEditProps
> = ({ permissionRole }) => (
  <ModalDefault
    header="Edit Role"
    viewComponent={({ toggleModal }) => (
      <ActionComponent
        onClick={toggleModal}
        type="option"
        icon="pencil"
        text="Edit"
      />
    )}
    content={({ toggleModal }) => (
      <PermissionRoleFormEdit
        permissionRole={permissionRole}
        options={{ onSuccess: toggleModal }}
      />
    )}
  />
);
